<div id="content" class="allcp-form" ng-controller="SettingController" ng-init="newForm()">
	<form ng-submit="saveForm()" class="form-horizontal allcp-form" novalidate>
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div class="row mt20">
			
			<div class="col-md-3">
				<div class="panel">
					<div class="panel-heading">
						<span class="panel-title"> Form Alanları</span>
						<hr>
					</div>
					<ul class="list-group">
						<li class="list-group-item">
							Yazı
							<a href="#" ng-click="addFormField('text')" class="pull-right">Ekle</a>
						</li>
						<li class="list-group-item">
							Uzun Yazı
							<a href="#" ng-click="addFormField('textbox')" class="pull-right">Ekle</a>
						</li>
						<li class="list-group-item">
							Numara
							<a href="#" ng-click="addFormField('number')" class="pull-right">Ekle</a>
						</li>
						<li class="list-group-item">
							Checkbox (Çoklu Seçim)
							<a href="#" ng-click="addFormField('checkbox')" class="pull-right">Ekle</a>
						</li>
						<li class="list-group-item">
							Radio (Tekli Seçim)
							<a href="#" ng-click="addFormField('radio')" class="pull-right">Ekle</a>
						</li>
						<li class="list-group-item">
							Barkod
							<a href="#" ng-click="addFormField('barkod')" class="pull-right">Ekle</a>
						</li>
						<li class="list-group-item">
							Resim
							<a href="#" ng-click="addFormField('image')" class="pull-right">Ekle</a>
						</li>
						<!-- <option value="sign">İmza</option> -->
						<li class="list-group-item">
							Tarih
							<a href="#" ng-click="addFormField('date')" class="pull-right">Ekle</a>
						</li>
					</ul>
				</div>
			</div>

			<div class="col-md-5">
				<div class="panel">
					<div class="panel-heading">
						<span class="panel-title"> Form Adı</span>
						<hr>
					</div>

					<div class="form-group">
						<label for="name21" class="field prepend-icon">
							<input type="text" ng-model="form.name" class="gui-input br-light light" placeholder="Form Adı Giriniz" required>
							<label for="name21" class="field-icon">
								<i class="fa fa-list-alt"></i>
							</label>
						</label>						
					</div>

					<div class="panel-heading mt40">
						<span class="panel-title"> Form Alanları</span>
						<hr>
					</div>

					<ul class="list-group" ui-sortable ng-model="form.fields">

						<li class="list-group-item" ng-repeat="item in form.fields">
							<a href="#" class="pull-left mr10">
								<i class="fa fa-bars"></i>
							</a>	
							<span>
								{{ item.field_name }} 
								<small ng-if="item.field_type == 'text'"> ( Yazı) </small>
								<small ng-if="item.field_type == 'textbox'"> ( Uzun Yazı) </small>
								<small ng-if="item.field_type == 'number'"> ( Numara) </small>
								<small ng-if="item.field_type == 'checkbox'"> ( Checkbox (Çoklu Seçim)) </small>
								<small ng-if="item.field_type == 'radio'"> ( Radio (Tekli Seçim)) </small>
								<small ng-if="item.field_type == 'barkod'"> ( Barkod) </small>
								<small ng-if="item.field_type == 'image'"> ( Resim) </small>
								<small ng-if="item.field_type == 'date'"> ( Tarih) </small>
							</span>
							<small ng-if="item.field_value.length > 0">
								| ({{ item.field_value }})
							</small>
							<small ng-if="item.field_reqiured">
								| (Mecburi)
							</small>
							<small ng-if="!item.field_reqiured">
								| (Mecburi Değil)
							</small>
							<a href="#" ng-click="deleteFormData($index)" class="pull-right" style="color:#8da2b3;">Sil</a>
							<a href="#" ng-click="editFormField(item)" data-dismiss="modal" data-toggle="modal" data-target="#edit" class="pull-right mr10" style="color:#8da2b3;">Düzenle</a>
						</li>

					</ul> 

					<button type="submit" class="btn btn-warning mt30 pull-right" style="height: 30px;line-height: 20px;font-weight:600"> Kaydet</a>
						
				</div>
			</div>

			<div class="modal right fade" id="edit" tabindex="-1" role="dialog" aria-labelledby="editLabel">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						<h5 class="modal-title"> 
							<strong> Alan Detayları</strong>
						</h5>
					</div>
					<div class="modal-body">
						<div class="panel">
							<div class="panel-heading">
								<span class="panel-title"> Alan Detayları</span>
								<hr>
							</div>
							
							<div class="form-group">
								<label class="mb10"><strong>Alan Adı
									<a href="#" class="hint--medium hint--top" 
										aria-label="*Form içerisinde alacağınız değerlerin tanımlamalarını belirleyin. Örneğin ‘’Ad Soyad’’ , ‘’Telefon Numarası’’,’’Müşteri Notu’’">
									<i class="fa fa-question-circle"></i> </a> 
									</strong>
								</label>
								<label class="field">
									<input type="text" ng-model="edit.field_name" class="gui-input" placeholder="Alan Adı" required>
								</label>
							</div>
							<div class="form-group">
								<label class="mb10"><strong>Alan Değeri
									<a href="#" class="hint--medium hint--top" 
										aria-label="*Alan değeri ‘’çoklu seçim’’ sorgularınızda istediğiniz seçenekleri belirlemenizi sağlar aynı zamanda sürekli tekrarlayan sorgularınızda yerleşik bulunması gereken bilgileri girmenize olanak tanır.">
									<i class="fa fa-question-circle"></i> </a> 
									</strong>
								</label>
								<label class="field">
									<input type="text" ng-model="edit.field_value" class="gui-input" placeholder="Alan Değeri">
									<p class="help-block" ng-if="item.field_type == 'checkbox' || item.field_type == 'radio'">
										Seçimleri ayırmak için girdiğiniz değerler arasına virgül koymanız gerekmektedir. Örn : Seçim 1, Seçim 2
									</p>
								</label>
							</div>
							<!--
							<div class="form-group">
								<label class="mb10"><strong>İzin</strong></label>
								<label for="permission" class="field select">
									<select id="sector" name="sector" ng-model="edit.permission" required>
										<option value="1">Okuma & Yazma</option>
										<option value="0">Okuma</option>
									</select>
									<i class="arrow"></i>
								</label>
							</div>
							-->
							<div class="form-group">
								<label class="mb10"><strong>Mecburiyet
									<a href="#" class="hint--medium hint--top" 
										aria-label="*İzin istediğiniz sorgunun zorunlulugunu belirler örneğin ‘’mail adresi’’ alan adı oluşturdunuz fakat bunun formda doldurulması gereken bir zorunluluk olmasını istemiyorsanız ‘’mecburi değil’’ yapabilirsiniz.">
									<i class="fa fa-question-circle"></i> </a> 
									</strong>
								</label>
								<label for="field_reqiured" class="field select">
									<select id="sector" name="sector" ng-model="edit.field_reqiured" required>
										<option value="1">Mecburi</option>
										<option value="0">Mecburi Değil</option>
									</select>
									<i class="arrow"></i>
								</label>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">Kapat</button>
						<button type="submit" class="btn btn-primary" data-dismiss="modal">Güncelle</button>
					</div>
					</div>
				</div>
			</div>

		</form>
	</div>
</div>